import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const razorpayPostOrderApi = createAsyncThunk('razorpayPostOrder', async () => {
    const response = await axiosInstance.post('/redeem/postOrder');
    return response.data;
});

const razorpayPostOrderSlice = createSlice({
    name: "razorpayPostOrder",
    initialState: {
        data: [],
        errors: [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(razorpayPostOrderApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(razorpayPostOrderApi.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(razorpayPostOrderApi.rejected, (state, action) => {
                state.errors.push(action.error.message);
                state.loading = false;
            });
    }
});

export default razorpayPostOrderSlice.reducer;
